import { defineStore } from 'pinia';
import { IData } from '@/types/globalTypes';
import { useUriStore } from '@/pinia/general/uri';
import axios, { AxiosError } from 'axios';
import { errorStatuses } from '@/const/statuses';

interface IErrorState {
  name: string;
  message: string;
  debugInfo: string;
}

interface IErrorData extends AxiosError {
  notDebugInfo?: boolean;
}

export const useErrorStore = defineStore('error', {
  state: (): IErrorState => ({
    name: '',
    message: '',
    debugInfo: '',
  }),
  actions: {
    handleSetError(eData: IErrorData) {
      let { name = '', message = '', config, response, code, status, notDebugInfo } = eData;
      let _errorMessage = `${name} ${message}`;
      name = name === 'AxiosError' ? 'Ошибка сервера' : 'Ошибка клиента';

      if (response) {
        if (status === 501 || status === 502) {
          name = 'Сервер временно недоступен, зайдите позже';
          _errorMessage = '';
        } else {
          //@ts-ignore
          const { message, errorMessage } = response.data;

          _errorMessage =
            message ||
            errorMessage ||
            (typeof response?.data === 'string' ? response?.data : getMessageByErrorCode(status));
        }
      }

      this.name = name;
      this.message = _errorMessage;

      const isDebug = true; //process.env.VUE_APP_DEBUG === 'true';

      if (isDebug && !notDebugInfo) {
        const params = config?.data && config.data.length < 500 ? '\n' + config.data : undefined;
        this.debugInfo = [status, config?.method, config?.url, code, params].filter((r) => r).join(' ');
      }
    },

    async setError(e: IErrorData) {
      // Пропускаем при разлогинивание пользователя
      if (e.response?.status === 403 || e.response?.status === 429) {
        return;
      }
      this.handleSetError(e);
    },

    clearError() {
      this.name = '';
      this.message = '';
      this.debugInfo = '';
    },
  },
  getters: {
    error: (state): IErrorState => state,
  },
});

function getMessageByErrorCode(status: number | undefined) {
  //@ts-ignore
  return status ? errorStatuses[status] || 'Неизвестная ошибка' : 'Проблема связанная с сетью';
}
